// src/api/tenantPublikApi.js
// API client untuk kontribusi masyarakat (tenant baru & foto baru).
import axios from "axios";

const API_BASE = "https://berkah.bondowosokab.go.id:5500";
const API_KEY = "7039338ec2fa8ac649760ddd8404b711b207479377c846d41d5d24b7b21beb97";

const headers = { "Bondowoso-Berkah": API_KEY };

// Foto dari HP bisa 4-8 MB. Perkecil di browser dulu supaya upload cepat & hemat kuota.
export async function kompresGambar(file, { sisiMaks = 1600, kualitas = 0.82 } = {}) {
    if (!file || !file.type || !file.type.startsWith("image/")) return file;
    if (file.type === "image/gif") return file;

    try {
        const bitmap = await new Promise((resolve, reject) => {
            const url = URL.createObjectURL(file);
            const img = new Image();
            img.onload = () => {
                URL.revokeObjectURL(url);
                resolve(img);
            };
            img.onerror = (e) => {
                URL.revokeObjectURL(url);
                reject(e);
            };
            img.src = url;
        });

        const skala = Math.min(1, sisiMaks / Math.max(bitmap.width, bitmap.height));
        const w = Math.round(bitmap.width * skala);
        const h = Math.round(bitmap.height * skala);

        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        canvas.getContext("2d").drawImage(bitmap, 0, 0, w, h);

        const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", kualitas));
        // kalau hasil malah lebih besar (jarang), pakai file asli
        if (!blob || blob.size >= file.size) return file;

        const namaBaru = file.name.replace(/\.[^.]+$/, "") + ".jpg";
        return new File([blob], namaBaru, { type: "image/jpeg" });
    } catch (e) {
        return file; // gagal kompres -> kirim apa adanya
    }
}

function ambilPesanError(e, fallback) {
    return e?.response?.data?.message || fallback;
}

export async function ajukanTenantBaru(form, files = []) {
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => {
        if (v !== null && v !== undefined) fd.append(k, v);
    });
    const terkompres = await Promise.all(files.map((f) => kompresGambar(f)));
    terkompres.forEach((f) => fd.append("foto", f));

    try {
        const res = await axios.post(`${API_BASE}/tenant-publik`, fd, { headers });
        return { ok: true, message: res.data?.message };
    } catch (e) {
        return { ok: false, message: ambilPesanError(e, "Gagal mengirim data. Coba lagi.") };
    }
}

export async function ajukanFotoBaru({ tenant_id, keterangan, nama_pengirim, website }, files = []) {
    const fd = new FormData();
    fd.append("tenant_id", tenant_id);
    if (keterangan) fd.append("keterangan", keterangan);
    if (nama_pengirim) fd.append("nama_pengirim", nama_pengirim);
    fd.append("website", website || "");
    const terkompres = await Promise.all(files.map((f) => kompresGambar(f)));
    terkompres.forEach((f) => fd.append("foto", f));

    try {
        const res = await axios.post(`${API_BASE}/tenant-publik/foto`, fd, { headers });
        return { ok: true, message: res.data?.message };
    } catch (e) {
        return { ok: false, message: ambilPesanError(e, "Gagal mengirim foto. Coba lagi.") };
    }
}